/**
 * Метод для получения массива возможных предоплат по операторам
 * @Return IOperatorDataForPartialPayment[]
 */

import _ from 'underscore';

const prepareOperatorsDataForPartialPaymentPopup = (operatorsIds, firstPaymentDefinitions) => _.reduce(operatorsIds, (accOperators, tourOperatorId) => {
        const currentOperator = _.reduce(firstPaymentDefinitions, (acc, firstPaymentDefinition) => {
            if (tourOperatorId && tourOperatorId !== firstPaymentDefinition?.operator) {
                return acc;
            }

            const itemIndex = _
                .findIndex(acc, (item) => item?.operator?.id === firstPaymentDefinition?.operator);

            const currentFirstPaymentDefinition = _.pick(firstPaymentDefinition,
                'daysAfterReservationForFullPayment',
                'daysBeforeCheckInDateForFullPayment',
                'minDaysAvailableBeforeCheckInDate',
                'minDaysAvailableBeforeFreeCancellationDate',
                'daysBeforeFreeCancellationDateForFullPayment',
                'firstPaymentPart');

            if (itemIndex === -1) {
                acc.push({
                    operator: {
                        id: firstPaymentDefinition?.operator,
                        cover: firstPaymentDefinition?.operatorCover,
                    },

                    firstPaymentDefinitions: [currentFirstPaymentDefinition],
                });

                return acc;
            }

            acc[itemIndex].firstPaymentDefinitions.push(currentFirstPaymentDefinition);
            return acc;
        }, []);

        return accOperators.concat(currentOperator);
    }, []);

export default prepareOperatorsDataForPartialPaymentPopup;
